import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Torre 1": { initFrame:  0 },
    "Torre 2": { initFrame:  0 },

    "Portería Antao": {initFrame: 0},
    "Piscina infantil Antao": {initFrame: 120},
    "Juegos de niños Antao": {initFrame: 120},
    "Baños piscina Antao": {initFrame: 120},
    "Cuartos técnicos Antao": {initFrame: 120},

    "Portería Porto Novo": {initFrame: 0},
    "Cancha de tenis Porto Novo": {initFrame: 130},
    "Baños de piscinas Porto Novo": {initFrame: 130},
    "Cuarto de basuras Porto Novo": {initFrame: 0},
    "Piscina adultos Porto Novo": {initFrame: 130},
    "Piscina niños Porto Novo": {initFrame: 130},
    "Salón Social - Quiosco 1 Porto Novo": {initFrame: 130},
    "Parque infantil Porto Novo": {initFrame: 130},
    "Tren de madera Porto Novo": {initFrame: 130},
    "Balancines Porto Novo": {initFrame: 130},
    "Piscina niños 2 Porto Novo": {initFrame: 50},
    "Piscina adultos 2 Porto Novo": {initFrame: 50},
    "Playa Porto Novo": {initFrame: 50},
    "Sauna y Turco Porto Novo": {initFrame: 50},
    "Gimnasio Porto Novo": {initFrame: 50},
    //"EveryTransition": { importTransition: AllTransitions }
}
